
export enum BalancePoint {
  Calculated = 0,
  BoilingPoint = 1,
  DewPoint = 2
}